<template>
  <div>
    <v-tabs v-if="lAction === 'view'"
    v-model="tab"
    flat
    background-color="primary"
    dark
    height="40"
    grow grow>
    <v-tab v-for="(tabItem, n) in tabItems" :key="n" :href="`#tab-${n}`">
      {{ tabItem + (tabItem === 'In Progress' ? ' (' + inProgressTab.length + ')' : tabItem === 'Completed' ? ' (' + completedTab.length + ')' : '' ) }}
    </v-tab>
  </v-tabs>
  <v-container fluid grid-list-md class="pt-0 px-2 ma-0">
    <v-layout row wrap>
      <v-flex xs12 mx-auto class="ma-1 pa-2">
        <v-tabs-items v-model="tab">
          <v-tab-item v-for="(tabItem, n) in tabItems" :key="n" :value="`tab-${n}`">
            <v-layout class="pa-0" row wrap>
              <v-flex xs12 mx-auto v-if="tab !== 'tab-2'">
                <v-card flat v-if="lAction === 'view'">
                  <v-card-title>
                    <v-flex xs6>
                      <v-text-field
                      class="pa-0"
                      append-icon="mdi-account-search"
                      :placeholder="$vuetify.breakpoint.smAndUp?'Search by Vendor Supplier Name etc.':'Search'"
                      hide-details
                      dense
                      v-model="search"
                      outlined
                      clearable
                      ></v-text-field>
                    </v-flex>
                  </v-card-title>
                  <v-card-text>
                    <v-layout>
                      <v-flex xs12 mx-auto>
                        <v-data-table
                        :headers="invoiceTrackHead"
                        :items="tabItem === 'In Progress' ? inProgressTab : completedTab"
                        hide-default-footer
                        hide-default-header
                        disable-pagination
                        dense
                        :search="search"
                        :mobile-breakpoint="0"
                        class="elevation-1">
                        <template v-slot:header="{ props: { headers } }">
                          <thead>
                            <tr>
                              <th class="primary lighten-2 white--text" style="font-size: 13px; width: 50px; text-align: center">{{headers[0].text}}</th>
                              <th class="primary lighten-2 white--text" style="font-size: 13px; width: 150px; text-align: center">{{headers[1].text}}</th>
                              <th class="primary lighten-2 white--text" style="font-size: 13px; width: 230px; text-align: left">{{headers[2].text}}</th>
                              <th class="primary lighten-2 white--text" style="font-size: 13px; width: 230px; text-align: left">{{headers[3].text}}</th>
                              <th class="primary lighten-2 white--text" style="font-size: 13px; width: 230px; text-align: left">{{headers[4].text}}</th>
                              <th class="primary lighten-2 white--text" style="font-size: 13px; width: 150px; text-align: center">{{headers[5].text}}</th>
                              <th class="primary lighten-2 white--text" style="font-size: 13px; width: 120px; text-align: right">{{headers[6].text}}</th>
                              <th class="primary lighten-2 white--text" style="font-size: 13px; width: 140px; text-align: right">{{headers[7].text}}</th>
                              <th class="primary lighten-2 white--text" style="font-size: 13px; width: 150px; text-align: center">{{headers[8].text}}</th>
                              <th class="primary lighten-2 white--text" style="font-size: 13px; width: 120px; text-align: center">{{headers[9].text}}</th>
                              <th class="primary lighten-2 white--text" style="font-size: 13px; width: 50px; text-align: center">{{headers[10].text}}</th>
                            </tr>
                          </thead>
                        </template>
                        <template slot="item" slot-scope="props">
                          <tr>
                            <td style="text-align:center; font-size: 12px">{{ props.item.inv_id }}</td>
                            <td style="text-align:center; font-size: 12px">{{ handy.formatDate(props.item.delivered_dt) }}</td>
                            <td style="text-align:left; font-size: 12px">{{ props.item.vendorsupplier_name }}</td>
                            <td style="text-align:left; font-size: 12px">{{ props.item.proj_name }}</td>
                            <td style="text-align:left; font-size: 12px">{{ props.item.services }}</td>
                            <td style="text-align:center; font-size: 12px">{{ props.item.order_number }}</td>
                            <td style="text-align:right; font-size: 12px">{{ handy.formatCur(props.item.inv_amount_bef_tax) }}</td>
                            <td style="text-align:right; font-size: 12px">{{ handy.formatCur(props.item.inv_amount_after_tax) }}</td>
                            <td style="text-align:center; font-size: 12px">{{ props.item.inv_type }}</td>
                            <td style="text-align:center; font-size: 12px">{{ props.item.status }}</td>
                            <td style="text-align:center; font-size: 12px">
                              <v-menu
                              :close-on-content-click="false"
                              top right class="mt-0">
                              <template v-slot:activator="{ on }">
                                <v-btn small icon v-on="on">
                                  <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item @click="prepareUpdate(props.item)">
                                  <v-list-item-avatar><v-icon>mdi-pencil</v-icon></v-list-item-avatar>
                                  <v-list-item-title>Update</v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="config.IS_EDITED_BY_USER" @click="deleteInv(props.item)">
                                  <v-list-item-avatar><v-icon>mdi-delete</v-icon></v-list-item-avatar>
                                  <v-list-item-title>Delete</v-list-item-title>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item @click="loadTimeLine(props.item.inv_id)">
                                  <v-list-item-avatar><v-icon>mdi-chart-line-variant</v-icon></v-list-item-avatar>
                                  <v-list-item-title>Timeline</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-flex xs12 sm8 v-if="tab === 'tab-2' && lAction === 'view'" mx-auto>
          <v-card-title class="title primary--text pa-3">
            Search Invoice List
          </v-card-title>
          <v-form ref="sForm" @submit.prevent="searchInvoice()">
            <v-card>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-select
                    v-model="lRep.proj_list"
                    :items="projList"
                    item-text="proj_name"
                    item-value="proj_id"
                    label="Project"
                    small-chips
                    clearable
                    hide-details
                    multiple
                    ></v-select>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                    v-model="lRep.vendorsupplier_list"
                    :items="vendorSuppliers"
                    item-text="vendorsupplier_name"
                    item-value="vendorsupplier_id"
                    label="Vendor Supplier Name"
                    clearable
                    small-chips
                    multiple
                    hide-details
                    ></v-select>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                    v-model="lRep.vendorsupplier_cat_list"
                    :items="vendorCatList"
                    item-text="vendorsupplier_cat"
                    item-value="vendorsupplier_cat_id"
                    label="Vendor Supplier Category"
                    hide-details
                    small-chips
                    multiple
                    clearable
                    ></v-select>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                    v-model="lRep.order_number"
                    label="Order Number"
                    hide-details
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                    v-model="lRep.inv_type"
                    :items="invType"
                    label="Invoice Type"
                    hide-details
                    clearable
                    ></v-select>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                    v-model="lRep.status"
                    :items="['In Progress', 'Completed']"
                    label="Status"
                    hide-details
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="clear">Clear</v-btn>
                <v-btn type="submit" color="accent" :disabled="beingSaved">search</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-flex>

        <v-flex xs12 class="pt-2" v-if="lAction === 'view' && searchinvoiceList.length > 0 && tab === 'tab-2'" grid-list-md>
          <v-card-title class="pa-0">
            <v-flex xs12 class="title primary--text pa-1">
              <span>Search Result ({{searchinvoiceList.length}} Records)</span>
            </v-flex>
          </v-card-title>
          <v-card flat>
            <v-card-text class="pa-1">
              <v-data-table
              :headers="invoiceTrackHead"
              :items="searchinvoiceList"
              hide-default-footer
              hide-default-header
              disable-pagination
              dense
              :search="search"
              :mobile-breakpoint="0"
              class="elevation-1">
              <template v-slot:header="{ props: { headers } }">
                <thead>
                  <tr>
                    <th class="primary lighten-2 white--text" style="font-size: 13px; width: 50px; text-align: center">{{headers[0].text}}</th>
                    <th class="primary lighten-2 white--text" style="font-size: 13px; width: 150px; text-align: center">{{headers[1].text}}</th>
                    <th class="primary lighten-2 white--text" style="font-size: 13px; width: 230px; text-align: left">{{headers[2].text}}</th>
                    <th class="primary lighten-2 white--text" style="font-size: 13px; width: 230px; text-align: left">{{headers[3].text}}</th>
                    <th class="primary lighten-2 white--text" style="font-size: 13px; width: 230px; text-align: left">{{headers[4].text}}</th>
                    <th class="primary lighten-2 white--text" style="font-size: 13px; width: 150px; text-align: center">{{headers[5].text}}</th>
                    <th class="primary lighten-2 white--text" style="font-size: 13px; width: 120px; text-align: right">{{headers[6].text}}</th>
                    <th class="primary lighten-2 white--text" style="font-size: 13px; width: 140px; text-align: right">{{headers[7].text}}</th>
                    <th class="primary lighten-2 white--text" style="font-size: 13px; width: 150px; text-align: center">{{headers[8].text}}</th>
                    <th class="primary lighten-2 white--text" style="font-size: 13px; width: 120px; text-align: center">{{headers[9].text}}</th>
                    <th class="primary lighten-2 white--text" style="font-size: 13px; width: 50px; text-align: center">{{headers[10].text}}</th>
                  </tr>
                </thead>
              </template>
              <template slot="item" slot-scope="props">
                <tr>
                  <td style="text-align:center; font-size: 12px">{{ props.item.inv_id }}</td>
                  <td style="text-align:center; font-size: 12px">{{ handy.formatDate(props.item.delivered_dt) }}</td>
                  <td style="text-align:left; font-size: 12px">{{ props.item.vendorsupplier_name }}</td>
                  <td style="text-align:left; font-size: 12px">{{ props.item.proj_name }}</td>
                  <td style="text-align:left; font-size: 12px">{{ props.item.services }}</td>
                  <td style="text-align:center; font-size: 12px">{{ props.item.order_number }}</td>
                  <td style="text-align:right; font-size: 12px">{{ handy.formatCur(props.item.inv_amount_bef_tax) }}</td>
                  <td style="text-align:right; font-size: 12px">{{ handy.formatCur(props.item.inv_amount_after_tax) }}</td>
                  <td style="text-align:center; font-size: 12px">{{ props.item.inv_type }}</td>
                  <td style="text-align:center; font-size: 12px">{{ props.item.status }}</td>
                  <td style="text-align:center; font-size: 12px">
                    <v-menu
                    :close-on-content-click="false"
                    top right class="mt-0">
                    <template v-slot:activator="{ on }">
                      <v-btn small icon v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="prepareUpdate(props.item)">
                        <v-list-item-avatar><v-icon>mdi-pencil</v-icon></v-list-item-avatar>
                        <v-list-item-title>Update</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="deleteInv(props.item)">
                        <v-list-item-avatar><v-icon>mdi-delete</v-icon></v-list-item-avatar>
                        <v-list-item-title>Delete</v-list-item-title>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item @click="loadTimeLine(props.item.inv_id)">
                        <v-list-item-avatar><v-icon>mdi-chart-line-variant</v-icon></v-list-item-avatar>
                        <v-list-item-title>Timeline</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>

  </v-tab-item>
</v-tabs-items>
</v-flex>

<v-btn
:style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:15px;':'bottom:15px; right:15px;')"
dark fab fixed color="accent" v-if="lAction === 'view' && tab !== 'tab-2' && config.IS_EDITED_BY_USER"
@click.native="prepareCreate">
<v-icon>mdi-plus</v-icon>
</v-btn>

<v-btn v-if="lAction === 'view' && tab !== 'tab-2' && config.IS_EDITED_BY_USER"
:style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; left:15px;':'bottom:15px; left:300px;')"
dark fab fixed small
color="accent black--text"
@click.native="prepareUpload">
<v-icon>mdi-upload</v-icon>
</v-btn>

<!-- create, update and delete of invoice tracker -->
<v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-0" fluid full-height>
  <v-layout row wrap>
    <v-flex xs12 sm8 mx-auto class="ma-2">
      <v-form ref="vForm" @submit.prevent="saveInvoiceChanges(lAction)">
        <v-card flat>
          <v-flex xs12 mx-auto>
            <v-card-title class="title pa-0">
              {{ handy.startWithUpper(lAction) + ' Invoice' }}
            </v-card-title>
            <v-card-text class="pa-1">
              <v-layout row wrap>
                <v-flex xs4>
                  <v-dialog ref="deliveredDate"
                  persistent v-model="deliveredDate"
                  max-width="290px"
                  :return-value.sync="lInv.delivered_dt"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                    slot="activator" label="Delivered Date"
                    v-model="lInv.delivered_dt"
                    append-icon="mdi-calendar-today"
                    readonly clearable
                    v-on="on"
                    :rules="[rules.required]"
                    hide-details
                    required
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="lInv.delivered_dt" scrollable
                  first-day-of-week="1"
                  >
                  <v-spacer></v-spacer>
                  <v-btn text @click="deliveredDate = false">Cancel</v-btn>
                  <v-btn text color="accent" @click="$refs.deliveredDate.save(lInv.delivered_dt)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs4>
              <v-combobox
              v-model="lInv.proj_pair"
              :items="showAllProject ? projList : projList.filter(rec => rec.proj_status === 'Active')"
              item-text="proj_name"
              item-value="proj_id"
              :rules="[rules.required]"
              label="Project"
              hide-details
              ></v-combobox>
            </v-flex>
            <v-flex sm4 class="text-xs-right">
              <v-switch
              v-model="showAllProject"
              label="Show all project"
              @change="$forceUpdate()"
              ></v-switch>
            </v-flex>
            <v-flex xs5>
              <v-select
              v-model="lInv.vendorsupplier_pair"
              :items="vendorSuppliers"
              item-text="vendorsupplier_name"
              item-value="vendorsupplier_id"
              :rules="[rules.required]"
              return-object
              label="Vendor Supplier Name"
              hide-details
              ></v-select>
            </v-flex>
            <v-flex xs1 class="pb-2">
              <v-btn fab small v-if="config.IS_EDITED_BY_USER" class="accent" :to="{path: '/vendorsupplier/'}"><v-icon>mdi-plus</v-icon></v-btn>
            </v-flex>
            <v-flex xs6>
              <v-select
              v-model="lInv.vendorsupplier_cat_pair"
              :items="vendorCatList"
              item-text="vendorsupplier_cat"
              item-value="vendorsupplier_cat_id"
              label="Vendor Supplier Category"
              :rules="[rules.required]"
              hide-details
              return-object
              @input="loadVendorSupplierSubCategory(lInv.vendorsupplier_cat_pair)"
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-select
              v-model="lInv.vendorsupplier_sub_cat_pair"
              :items="vendorSubCatList"
              item-text="vendorsupplier_sub_cat"
              item-value="vendorsupplier_sub_cat_id"
              label="Vendor Supplier Sub-Category"
              :rules="[rules.required]"
              return-object
              hide-details
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-text-field
              v-model="lInv.order_number"
              label="Order Number"
              hide-details
              maxlength="25"
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
              v-model="lInv.supplier_invoice_no"
              label="Supplier Invoice Number"
              hide-details
              maxlength="25"
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
              v-model="lInv.inv_amount_bef_tax"
              label="Invoice Amount Before Tax"
              :rules="[rules.required]"
              hide-details
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
              v-model="lInv.inv_amount_after_tax"
              :rules="[rules.required]"
              label="Invoice Amount After Tax"
              hide-details
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-select
              v-model="lInv.inv_type"
              :items="invType"
              label="Invoice Type"
              :rules="[rules.required]"
              hide-details
              @input="loadInvType()"
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-text-field
              v-model="lInv.uni_invoice_month"
              label="Uni Invoice Month"
              :rules="[rules.required]"
              hide-details
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
              v-model="lInv.uni_invoice_number"
              label="Uni Invoice Number"
              hide-details
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-select
              v-model="lInv.status"
              :items="['In Progress', 'Completed']"
              label="Status"
              hide-details
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-text-field
              v-model="lInv.remarks"
              label="Remarks"
              hide-details
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <input style="display:none" type="file" ref="fileInput"
              accept=".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg" multiple @change="loadFilesFromFileBrowser(lInv)"/>
              <v-btn @click="pickFile" icon><v-icon>mdi-attachment</v-icon></v-btn>
              <span v-if="lInv.files && lInv.files.filter(rec => rec.is_selected).length > 0">
                <span v-for="(file, index) in lInv.files.filter(rec => rec.is_selected)" :key="index">
                  <v-chip v-model="file.is_selected" @click:close="removeSelectedFile(file)" close>
                    <span v-if="!file.is_changed">
                      <a :href="handy.loadImg(file.file_url)" download style="text-decoration: none;">
                        <v-btn small icon class="ml-0 info grey--text text--lighten-4">
                          <v-icon small>mdi-download</v-icon>
                        </v-btn>
                      </a>
                    </span>
                    <span style="font-size: 12px;" class="ml-2">{{ file.file_name }}</span>
                  </v-chip>
                </span>
              </span>
              <span v-else class="caption">Attachment if any <strong class="info--text" style="font-size: 14px">(upto 2 MB) </strong></span>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="pt-3">
          <v-layout row wrap>
            <v-spacer></v-spacer>
            <v-btn @click.stop="cancelChanges">Cancel</v-btn>
            <v-btn type="submit" v-if="config.IS_EDITED_BY_USER" color="accent black--text" :disabled="beingSaved">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-flex>
    </v-card>
  </v-form>
</v-flex>
</v-layout>
</v-container>

<!-- 3. show Timeline for particular ticket_id -->
<v-dialog v-model="showTimeline" scrollable max-width="600px">
  <v-card>
    <v-card-title class="py-1 title primary white--text">
      <div>Timeline</div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showTimeline = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pl-0 pr-4 py-3">
      <v-timeline dense class="pt-0">
        <v-timeline-item :class="n === lTimeLine.length-1 ? 'pb-0' : ''"
        v-for="(timeline, n) in lTimeLine"
        :key="n"
        small
        :id="'timeline_' + n"
        >
        <template v-slot:icon>
          <v-avatar>
            <img :src="handy.loadImg(timeline.created_avatar_url, true)">
          </v-avatar>
        </template>
        <v-card>
          <div v-if="timeline.action === 'Invoice Updated'">
            <v-card-title class="title pa-2">
              {{ timeline.action }}
            </v-card-title>
            <v-card-text class="pt-0 pb-2">
              <div v-if="timeline.notes !== ''">
                <div v-if="timeline.action === 'Invoice Updated'">
                  <div><b>Notes: </b>
                    <div v-for="(note, i) in timeline.timeLineNote" :key="i">
                      <span v-if="note">{{ i+1 + '. ' + note }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </v-card-text>
          </div>
          <div v-else>
            <v-card-title class="title pa-2">
              {{ timeline.action }}
            </v-card-title>
          </div>
          <v-container grid-list-sm class="pa-0" v-if="lTimeLine.attachImages && lTimeLine.attachImages.filter(rec => rec.action === timeline.action && timeline.inv_track_det_id === rec.inv_track_det_id).length ||
          lTimeLine.attachFile && lTimeLine.attachFile.filter(rec => rec.action === timeline.action && timeline.inv_track_det_id === rec.inv_track_det_id)">
          <v-layout row wrap>
            <v-flex xs12 sm10 v-if="lTimeLine.attachImages.length && lTimeLine.attachImages.filter(rec => rec.action === timeline.action).length > 0">
              <v-flex xs12 v-if="(lTimeLine.attachImages.filter(rec => rec.action === timeline.action && rec.inv_track_det_id === timeline.inv_track_det_id).length > 0) && (lTimeLine.attachFile.filter(rec => rec.action === timeline.action && rec.inv_track_det_id === timeline.inv_track_det_id).length > 0)">
                <v-layout row wrap class="caption grey--text mb-2">
                  <v-flex xs6 sm8 class="ml-1">
                    Image Attachments
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <div v-viewer="options" class="clearfix">
                  <template v-for="(file, index) in lTimeLine.attachImages">
                    <span v-if="(file.action === timeline.action && file.inv_track_det_id === timeline.inv_track_det_id)">
                      <img width="80px" :src="handy.loadImg(file.file_url)" :key="index" class="ma-1" style="display: inline-block; cursor: pointer;">
                    </span>
                  </template>
                </div>
              </v-flex>
            </v-flex>
            <v-flex xs12 sm10 v-if="lTimeLine.attachFile.length && lTimeLine.attachFile.filter(rec => rec.action === timeline.action).length > 0">
              <v-flex xs12 v-if="(lTimeLine.attachImages.filter(rec => rec.action === timeline.action && rec.inv_track_det_id === timeline.inv_track_det_id).length > 0) && (lTimeLine.attachFile.filter(rec => rec.action === timeline.action && rec.inv_track_det_id === timeline.inv_track_det_id).length > 0)">
                <v-layout row wrap class="caption grey--text mb-2">
                  <v-flex xs6 sm8 class="ml-1">
                    Other Attachments
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <span v-for="(file, index) in lTimeLine.attachFile" :key="index" class="ma-1">
                  <v-chip v-if="(file.action === timeline.action && file.inv_track_det_id === timeline.inv_track_det_id)">
                    <a :href="handy.loadImg(file.file_url)" download style="text-decoration: none;">
                      <v-btn small icon class="mr-1 info grey--text text--lighten-4">
                        <v-icon small>mdi-download</v-icon>
                      </v-btn>
                    </a>
                    <span style="font-size: 12px;">{{file.file_name}}</span>
                  </v-chip>
                </span>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-container>
      <v-divider></v-divider>
      <v-card-actions class="caption pa-2">
        {{ timeline.created_by_name }}
        <span class="grey--text pl-2">{{ handy.formatDate(timeline.action_dt) + ' ' + handy.getTime12Hrs(timeline.action_dt) }}</span>
      </v-card-actions>
    </v-card>
  </v-timeline-item>
</v-timeline>
</v-card-text>
</v-card>
</v-dialog>

<!-- upload files -->
<v-container v-if="lAction === 'upload'" class="pa-0" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card flat>
        <v-card-title class="title pa-0 pl-3">
          Upload SC Invoice List
        </v-card-title>
        <div class="mt-3 text-center primary--text title font-italic">In just 4 steps</div>
        <v-card-text class="subtitle-1 black--text">
          <v-layout row wrap>
            <v-flex xs12>
              <v-chip small outlined class="info info--text mr-2">Step 1</v-chip>
              <span>Download template</span>
              <span style="float:right;">
                <form method="get" action="/files/Supply_Chain_Invoice_Template.xlsx">
                  <v-btn type="submit" class="mt-0 mb-0" small><v-icon>mdi-download</v-icon></v-btn>
                </form>
              </span>
            </v-flex>
            <v-flex xs12>
              <v-chip small outlined class="info info--text mr-2">Step 2</v-chip>
              <span>Fill-in details as guided in template</span>
            </v-flex>
            <v-flex style="margin-left: 70px;">
              <div style="font-size: 15px;">For project details download the csv file
                <v-download-as
                :headers="projectHead"
                :items="projList"
                title="Project List Details"
                :landscape="true"
                ></v-download-as>
              </div>
            </v-flex>
            <v-flex style="margin-left: 70px;">
              <div style="font-size: 15px;">For vendor suppliers details download the csv file
                <v-download-as
                :headers="VendorSupHead"
                :items="vendorSuppliersList"
                title="Vendor Suppliers Details"
                :landscape="true"
                ></v-download-as>
              </div>
            </v-flex>
            <v-flex xs12>
              <v-chip small outlined class="info info--text mr-2">Step 3</v-chip>
              <span>Save as CSV <span class="caption">(Comma delimited)</span><br />
              <span class="caption grey--text pl-4 ml-4">
                <span class="ml-4">Go with OK/Yes when prompted while saving</span>
              </span>
            </span>
          </v-flex>
          <v-flex xs12>
            <v-chip small outlined class="info info--text mr-2">Step 4</v-chip>
            <span>Upload the CSV file</span>
            <span style="float:right;"><v-btn small class="mt-0 mb-0 accent" @click.native="promptUpload"><v-icon>mdi-upload</v-icon></v-btn></span>
            <input style="display:none" ref="ipFile" type="file" accept=".csv" @change="validateFile()"/>
          </v-flex>
          <v-flex xs12>
            <div class="mt-3 text-center primary--text title font-italic">Smartility backbone takes care of rest</div>
          </v-flex>
          <v-flex xs12>
            <v-chip small outlined class="info info--text mr-2">Step 5</v-chip>
            <span>Validate your information</span>
          </v-flex>
          <v-flex xs12>
            <v-chip small outlined class="info info--text mr-2">Step 6</v-chip>
            <span>Create supply chain invoice list</span>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions class="pt-0 pr-4">
        <v-spacer></v-spacer>
        <v-btn @click.native="cancelChanges">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</v-layout>
</v-container>

<!-- validate and upload -->
<v-container v-if="lAction === 'validate'" class="pa-0" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card flat>
        <v-card-title class="title pa-0 pl-3">
          Upload SC Invoice List
        </v-card-title>
        <v-card-text class="text-center pl-2 pr-2">
          <v-layout row wrap>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12 class="info--text mb-2">
                  <span v-if="validateInProgress">Loading and validating the file...</span>
                  <span v-if="validFile && !validateInProgress">File validation is successfull <v-icon class="success--text">mdi-check</v-icon></span>
                  <span v-if="!validFile">File validation is failed <v-icon class="error--text">mdi-close</v-icon></span>
                  <span v-if="!validFile && headerIssue" class="error--text"><br />Invalid column headers, please ensure names and count are matching as per the template</span>
                  <span v-if="!validFile && !headerIssue" class="error--text"><br />One or more invalid records, review the table below.<br/>Click on the errored row to know more info.</span>
                  <span v-if="!totFail && !loadInProgress">Vendor list creation was successfull<v-icon class="success--text">mdi-check</v-icon></span>
                  <span v-if="!totLoaded && totFail && !loadInProgress"><br />Vendor list creation failed<v-icon class="error--text">mdi-close</v-icon></span>
                  <span v-if="totLoaded && totFail && !loadInProgress"><br />Vendor list creation partially failed<v-icon class="warning--text">mdi-close</v-icon></span>
                  <span v-if="totFail && !loadInProgress" class="error--text"><br />One or more failed records, review the table below.<br/>Click on the errored row to know more info.</span>
                </v-flex>
                <v-flex xs4 v-if="totRecs">
                  <v-progress-circular color="info"
                  :value="readyForLoad ? 100 : (recsLoaded.length/totRecs*100)"
                  :size="50" :width="7">
                  {{ readyForLoad ? totValid : recsLoaded.length }}
                </v-progress-circular>
                <br/><div class="caption grey--text">Records</div>
              </v-flex>
              <v-flex xs4 v-if="totRecs">
                <v-progress-circular color="success"
                :value="(totValid/totRecs*100)"
                :size="50" :width="7">
                {{ readyForLoad ? totLoaded : totValid }}
              </v-progress-circular>
              <br/><div class="caption grey--text">{{ readyForLoad ? 'Loaded' : 'Valid' }}</div>
            </v-flex>
            <v-flex xs4 v-if="totRecs">
              <v-progress-circular color="error"
              :value="(totInvalid/totRecs*100)"
              :size="50" :width="7">
              {{ readyForLoad ? totFail : totInvalid }}
            </v-progress-circular>
            <br/><div class="caption grey--text">{{ readyForLoad ? 'Failed' : 'Invalid' }}</div>
          </v-flex>
          <v-flex xs12>
            <v-btn class="mr-4" small @click.native="cancelUploadChanges">Cancel</v-btn>
            <v-btn v-if="totValid > 0" small class="accent" @click.native="uploadInvoice" :disabled="beingSaved">Process the valid records</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 class="mt-2" grid-list-md>
        <v-data-table
        :headers="headerSm"
        :items="recsLoaded"
        hide-default-footer
        :mobile-breakpoint="0"
        class="elevation-1 text-center"
        >
        <template slot="item" slot-scope="props">
          <tr :class="(props.item.error ? (props.item.load_status === 'Failed' ? 'error':'error--text') : (props.item.load_status === 'Loaded' ? 'success' : ''))" @click="props.item.error ? showError(props.item.error) : ''">
            <td>{{ props.item.proj_id }}</td>
            <td>{{ props.item.vendorsupplier_id }}</td>
            <td>{{ props.item.vendorsupplier_cat_id }}</td>
            <td>{{ props.item.vendorsupplier_sub_cat_id }}</td>
            <td>{{ props.item.delivered_dt }}</td>
            <td>{{ props.item.order_number }}</td>
            <td>{{ props.item.supplier_invoice_no }}</td>
            <td>{{ props.item.inv_amount_bef_tax }}</td>
            <td>{{ props.item.inv_amount_after_tax }}</td>
            <td>{{ props.item.inv_type }}</td>
            <td>{{ props.item.uni_invoice_month }}</td>
            <td>{{ props.item.uni_invoice_number }}</td>
            <td>{{ props.item.status }}</td>
            <td>{{ props.item.remarks }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</v-card-text>
<v-card-actions class="pt-0" v-if="false">
  <v-spacer></v-spacer>
  <v-btn @click.native="cancelChanges">Cancel</v-btn>
</v-card-actions>
</v-card>
</v-flex>
</v-layout>
</v-container>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="4000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-layout>
</v-container>
</div>
</template>

<script>
import handy from '@/utils/handy'
import config from '@/config/app-cfg'
import VDownloadAs from './VDownloadAs.vue'

import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Vue from 'vue'
Vue.use(Viewer)

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      handy: handy,
      rules: handy.rules,
      config: config,
      search: '',
      lAction: 'view',
      lInv: {},
      projList: [],
      deliveredDate: false,
      vendorCatList: [],
      vendorSubCatList: [],
      beingSaved: false,
      invType: ['Uniservice Scope', 'Individual Invoice', 'Add to Maint Invoice', 'Cust to Supplier'],
      showAllProject: false,
      vendorSuppliers: [],
      invoiceList: [],
      inProgressTab: [],
      completedTab: [],
      invoiceTrackHead: [
        { text: 'Inv.Id', value: 'inv_id' },
        { text: 'Delivered Date', value: 'delivered_dt' },
        { text: 'Vendor Supplier Name', value: 'vendorsupplier_name' },
        { text: 'Project Name', value: 'proj_name' },
        { text: 'Service Capability', value: 'services' },
        { text: 'Order Number', value: 'order_number' },
        { text: 'Inv.Amt', value: 'inv_amount_bef_tax' },
        { text: 'Inv.Amt Af.Tax', value: 'inv_amount_after_tax' },
        { text: 'Invoice Type', value: 'inv_type' },
        { text: 'Status', value: 'status' },
        { text: '', value: '' }
      ],
      tabItems: ['In Progress', 'Completed', 'Reports'],
      tab: 'tab-0',
      lTimeLine: [],
      showTimeline: false,
      previousData: [],
      lUpload: {},
      // file upload
      validateInProgress: true,
      readyForLoad: false,
      loadInProgress: true,
      validFile: true,
      headerIssue: false,
      fileError: false,
      totRecs: 0,
      recsLoaded: [],
      totValid: 0,
      totInvalid: 0,
      totLoaded: 0,
      totFail: 0,
      headerSm: [
        { text: 'Project id', value: 'proj_id', sortable: false },
        { text: 'Vendor supplier id', value: 'vendorsupplier_id', width: '100px', sortable: false },
        { text: 'Vendor supplier category id', value: 'vendorsupplier_cat_id', width: '130px', sortable: false },
        { text: 'Vendor supplier sub-category id', value: 'vendorsupplier_sub_cat_id', width: '130px', sortable: false },
        { text: 'Delivered date', value: 'delivered_dt', sortable: false, width: '150px' },
        { text: 'Order number', value: 'order_number', sortable: false },
        { text: 'Supplier invoice number', value: 'supplier_invoice_no', width: '130px', sortable: false },
        { text: 'Invoice amount before tax', value: 'inv_amount_bef_tax', width: '130px', sortable: false },
        { text: 'Invoice amount after tax', value: 'inv_amount_after_tax', width: '130px', sortable: false },
        { text: 'Invoice type', value: 'inv_type', sortable: false },
        { text: 'Uni invoice month', value: 'uni_invoice_month', width: '130px', sortable: false },
        { text: 'Uni invoice number', value: 'uni_invoice_number', width: '130px', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Remarks', value: 'remarks', sortable: false }
      ],
      reqHeaders: ['Project id', 'Vendor supplier id', 'Vendor supplier category id', 'Vendor supplier sub-category id', 'Delivered date', 'Order number', 'Supplier invoice number', 'Invoice amount before tax', 'Invoice amount after tax', 'Invoice type', 'Uni invoice month', 'Uni invoice number', 'Status', 'Remarks'],
      colNames: [
        {col_name: 'proj_id', is_required: true},
        {col_name: 'vendorsupplier_id', is_required: true},
        {col_name: 'vendorsupplier_cat_id', is_required: true},
        {col_name: 'vendorsupplier_sub_cat_id', is_required: true},
        {col_name: 'delivered_dt', is_required: true},
        {col_name: 'order_number', is_required: false},
        {col_name: 'supplier_invoice_no', is_required: false},
        {col_name: 'inv_amount_bef_tax', is_required: true},
        {col_name: 'inv_amount_after_tax', is_required: true},
        {col_name: 'inv_type', is_required: true},
        {col_name: 'uni_invoice_month', is_required: true},
        {col_name: 'uni_invoice_number', is_required: false},
        {col_name: 'status', is_required: false},
        {col_name: 'remarks', is_required: false}
      ],
      options: {
        toolbar: true,
        url: 'data-source'
      },
      lRep: {},
      dlgFromDate: false,
      dlgToDate: false,
      searchinvoiceList: [],
      projectHead: [
        { text: 'Project Id', value: 'proj_id' },
        { text: 'Project Name', value: 'proj_name' },
      ],
      vendorSuppliersList: [],
      VendorSupHead: [
        { text: 'Vendor Supplier Id', value: 'vendorsupplier_id' },
        { text: 'Vendor Supplier Name', value: 'vendorsupplier_name' },
        { text: 'Vendor Supplier Category Id', value: 'vendorsupplier_cat_id' },
        { text: 'Vendor Supplier Category', value: 'vendorsupplier_cat' },
        { text: 'Vendor Supplier Sub-Category Id', value: 'vendorsupplier_sub_cat_id' },
        { text: 'Vendor Supplier Sub-Category', value: 'vendorsupplier_sub_cat' }
      ]
    }
  },
  mounted () {
    this.loadInvoiceTrackerList()
    this.loadProjectList()
    this.loadVendorSupplierCategory()
    this.loadVendorSuppliers()
    this.loadVendorSuppliersDet()
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    prepareCreate () {
      this.lInv = {
        delivered_dt: '',
        proj_pair: '',
        vendorsupplier_cat_pair: '',
        vendorsupplier_sub_cat_pair: '',
        vendorsupplier_pair: '',
        order_number: null,
        vendorsupplier_name: '',
        supplier_invoice_no: null,
        inv_amount_bef_tax: '',
        inv_amount_after_tax: '',
        inv_type: '',
        status: 'In Progress',
        remarks: '',
        created_by: config.SV_USER_ID
      }
      this.lAction = 'create'
    },
    loadProjectList () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.projList = []
      this.axios.get(config.API_URL + '/getProjectsListByVendorId/', qry)
      .then(response => {
        this.projList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadVendorSupplierCategory () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getVendorSupplierCatList/', qry)
      .then(response => {
        this.vendorCatList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadVendorSupplierSubCategory (curInv) {
      var qry = {
        params: {
          vendorsupplier_cat_id: curInv.vendorsupplier_cat_id
        }
      }
      this.axios.get(config.API_URL + '/getVendorSupplierSubCatList/', qry)
      .then(response => {
        this.vendorSubCatList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadVendorSuppliers () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getVendorSuppliers/', qry)
      .then(response => {
        this.vendorSuppliers = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    saveInvoiceChanges (action) {
      if (!this.$refs.vForm.validate()) {
        return
      }
      if (action === 'update') {
        this.lInv.notes = ''
        if (this.previousData.proj_pair.proj_id !== this.lInv.proj_pair.proj_id) {
          this.lInv.notes += ' Project from "' + this.previousData.proj_pair.proj_name + '" to "' + this.lInv.proj_pair.proj_name + '",'
        }
        if (this.previousData.vendorsupplier_pair.vendorsupplier_id !== this.lInv.vendorsupplier_pair.vendorsupplier_id) {
          this.lInv.notes += ' Vendor supplier from "' + this.previousData.vendorsupplier_pair.vendorsupplier_name + '" to "' + this.lInv.vendorsupplier_pair.vendorsupplier_name + '",'
        }
        if (this.previousData.vendorsupplier_cat_pair.vendorsupplier_cat_id !== this.lInv.vendorsupplier_cat_pair.vendorsupplier_cat_id) {
          this.lInv.notes += ' Vendor supplier category from "' + this.previousData.vendorsupplier_cat_pair.vendorsupplier_cat + '" to "' + this.lInv.vendorsupplier_cat_pair.vendorsupplier_cat + '",'
        }
        if (this.previousData.vendorsupplier_sub_cat_pair.vendorsupplier_sub_cat_id !== this.lInv.vendorsupplier_sub_cat_pair.vendorsupplier_sub_cat_id) {
          this.lInv.notes += ' Vendor supplier sub-category from "' + this.previousData.vendorsupplier_sub_cat_pair.vendorsupplier_sub_cat + '" to "' + this.lInv.vendorsupplier_sub_cat_pair.vendorsupplier_sub_cat + '",'
        }
        if (this.previousData.delivered_dt !== this.lInv.delivered_dt) {
          this.lInv.notes += ' Delivered date from "'+ this.previousData.delivered_dt + '" to "' + this.lInv.delivered_dt + '",'
        }
        if (this.previousData.order_number !== this.lInv.order_number) {
          this.lInv.notes += ' Order number from "'+ this.previousData.order_number + '" to "' + this.lInv.order_number + '",'
        }
        if (this.previousData.supplier_invoice_no !== this.lInv.supplier_invoice_no) {
          this.lInv.notes += ' Supplier invoice number from "'+ this.previousData.supplier_invoice_no + '" to "' + this.lInv.supplier_invoice_no + '",'
        }
        if (this.previousData.inv_amount_bef_tax !== this.lInv.inv_amount_bef_tax) {
          this.lInv.notes += ' Invoice amt before tax from"'+ this.previousData.inv_amount_bef_tax + '" to "' + this.lInv.inv_amount_bef_tax + '",'
        }
        if (this.previousData.inv_amount_after_tax !== this.lInv.inv_amount_after_tax) {
          this.lInv.notes += ' Invoice amt after tax from "'+ this.previousData.inv_amount_after_tax + '" to "' + this.lInv.inv_amount_after_tax + '",'
        }
        if (this.previousData.inv_type !== this.lInv.inv_type) {
          this.lInv.notes += ' Invoice type from "'+ this.previousData.inv_type + '" to "' + this.lInv.inv_type + '",'
        }
        if (this.previousData.uni_univoice_month !== this.lInv.uni_univoice_month) {
          this.lInv.notes += ' Uni invoice month from "'+ this.previousData.uni_univoice_month + '" to "' + this.lInv.uni_univoice_month + '",'
        }
        if (this.previousData.uni_invoice_number !== this.lInv.uni_invoice_number) {
          this.lInv.notes += ' Uni invoice number from "'+ this.previousData.uni_invoice_number + '" to "' + this.lInv.uni_invoice_number + '",'
        }
        if (this.previousData.status !== this.lInv.status) {
          this.lInv.notes += ' status from "'+ this.previousData.status + '" to "' + this.lInv.status + '",'
        }
      }
      if (!this.lInv.files) {
        this.lInv.files = []
      }
      this.lInv.proj_id = this.lInv.proj_pair.proj_id
      this.lInv.vendorsupplier_cat_id = this.lInv.vendorsupplier_cat_pair.vendorsupplier_cat_id
      this.lInv.vendorsupplier_sub_cat_id = this.lInv.vendorsupplier_sub_cat_pair.vendorsupplier_sub_cat_id
      this.lInv.vendorsupplier_id = this.lInv.vendorsupplier_pair.vendorsupplier_id
      this.lInv.vendor_id = config.VENDOR_ID
      this.lInv.updated_by = config.SV_USER_ID
      this.lInv.action_by = config.SV_USER_ID
      this.beingSaved = true
      this.validateSize(this.lInv)
      this.axios.post(config.API_URL + '/invoiceTracker/' + action, this.lInv)
      .then(response => {
        this.lAction = 'view'
        this.loadInvoiceTrackerList()
        this.loadInvAttachment(this.lInv.inv_id)
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    cancelChanges () {
      this.lAction = 'view'
    },
    cancelUploadChanges () {
      this.lAction = 'upload'
      this.lUpload.proj_pair = []
      this.lUpload.vendorsupplier_pair = []
      this.lUpload.vendorsupplier_cat_pair = []
      this.lUpload.vendorsupplier_sub_cat_pair = []
    },
    loadInvType () {
      if (this.lInv.inv_type === 'Uniservice Scope') {
        this.lInv.uni_invoice_month = 'NA'
        this.lInv.uni_invoice_number = 'NA'
      } else {
        this.lInv.uni_invoice_month = ''
        this.lInv.uni_invoice_number = ''
      }
    },
    loadInvoiceTrackerList () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getInvoiceTrackerList/', qry)
      .then(response => {
        this.invoiceList = response.data
        this.inProgressTab = this.invoiceList.filter(rec => rec.status === 'In Progress')
        this.completedTab = this.invoiceList.filter(rec => rec.status === 'Completed')
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareUpdate (curInv) {
      this.lInv = Object.assign({}, curInv)
      this.lInv.delivered_dt = this.lInv.delivered_dt ? handy.formatDBDate(this.lInv.delivered_dt) : null
      this.lInv.vendorsupplier_pair = { vendorsupplier_id: this.lInv.vendorsupplier_id, vendorsupplier_name: this.lInv.vendorsupplier_name }
      this.lInv.proj_pair = { proj_id: this.lInv.proj_id, proj_name: this.lInv.proj_name }
      this.lInv.vendorsupplier_cat_pair = { vendorsupplier_cat_id: this.lInv.vendorsupplier_cat_id, vendorsupplier_cat: this.lInv.vendorsupplier_cat }
      this.lInv.vendorsupplier_sub_cat_pair = { vendorsupplier_sub_cat_id: this.lInv.vendorsupplier_sub_cat_id, vendorsupplier_sub_cat: this.lInv.vendorsupplier_sub_cat }
      this.lAction = 'update'
      this.previousData = Object.assign({}, this.lInv)
      this.loadVendorSupplierSubCategory(curInv)
      this.loadInvAttachment(curInv.inv_id)
    },
    loadTimeLine (curInvId) {
      var qry = {
        params: {
          inv_id: curInvId,
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getTimelineForInvoiceTracker/', qry)
      .then(response => {
        this.lTimeLine = response.data
        var timeLineNote = []
        timeLineNote = response.data.filter(rec => rec.action === 'Invoice Updated' && rec.notes !== null)
        if (timeLineNote) {
          var note = ''
          var cidx = 0
          for (var k = 0; k < timeLineNote.length; k++) {
            cidx = response.data.findIndex(rec => rec.inv_track_det_id === timeLineNote[k].inv_track_det_id)
            note = timeLineNote[k].notes.split(',')
            this.lTimeLine[cidx].timeLineNote = []
            for (var i = 0; i < note.length; i++) {
              this.lTimeLine[cidx].timeLineNote[i] = note[i]
            }
          }
        }
        this.loadInvAttachment(curInvId)
        this.showTimeline = true
        setTimeout(() => {
          var tmpItem = document.getElementById('timeline_' + (this.lTimeLine.length - 1))
          tmpItem.scrollIntoView()
        }, 100)
      })
      .catch(err => {
        this.msg(err, 0)
        this.lTimeLine = []
        this.showTimeline = false
      })
    },
    prepareUpload () {
      this.lAction = 'upload'
      this.lUpload = {
        proj_pair: '',
        vendorsupplier_pair: '',
        vendorsupplier_cat_pair: '',
        vendorsupplier_sub_cat_pair: ''
      }
    },
    promptUpload () {
      this.$refs.ipFile.click()
    },
    validateFile () {
      this.lAction = 'validate'
      this.validateInProgress = true
      this.loadInProgress = true
      this.validFile = true
      this.headerIssue = false
      this.fileError = false
      this.totRecs = 0
      this.recsLoaded = []
      this.totValid = 0
      this.totInvalid = 0
      this.totLoaded = 0
      this.totFail = 0

      // read file
      var file = this.$refs.ipFile.files[0]

      var reader = new FileReader()
      reader.onload = (e) => {
        var content = e.target.result

        // validate & show result
        var allLines = content.split(/\r\n|\n/)
        // ignore empty lines if any
        allLines = allLines.filter(rec => !rec.startsWith(',,,,'))
        this.totRecs = allLines.length - 1
        var headers = allLines[0].split(',')
        // 1. header & required columns
        for (var i = 0; i < this.reqHeaders.length; i++) {
          if (headers[i] !== this.reqHeaders[i]) {
            this.validateInProgress = false
            this.validFile = false
            this.headerIssue = true
            return
          }
        }
        // 2. validate each record
        var res = {}
        var curRec = []
        for (var j = 1; j < allLines.length; j++) {
          if (allLines[j]) {
            curRec = allLines[j].split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/)
            res = {'error': ''}
            for (var c = 0; c < this.colNames.length; c++) {
              if (this.colNames[c].is_required && curRec[c].trim() === '') {
                // special validation
                res['error'] += this.reqHeaders[c] + ' is empty; '
              } else {
                res[this.colNames[c].col_name] = curRec[c] && curRec[c].indexOf('"') >= 0 ? curRec[c].split('"').join('') : curRec[c]
              }
            }
            this.recsLoaded.push(res)
            if (res['error']) {
              this.totInvalid++
            } else {
              this.totValid++
            }
          }
        }
        if (this.totInvalid) {
          this.validFile = false
        }
        this.validateInProgress = false
      }
      reader.readAsText(file)
    },
    showError (err) {
      this.msg(err, 2)
    },
    async uploadInvoice () {
      // create invoice List one by one
      this.readyForLoad = true
      this.loadInProgress = true
      this.beingSaved = true
      var curRec = ''
      var tmpDt = null
      for (var i = 0; i < this.recsLoaded.length; i++) {
        curRec = this.recsLoaded[i]
        if (!this.recsLoaded[i].error) { // process only valid records
          // fill-in gaps
          this.recsLoaded[i].vendor_id = config.VENDOR_ID
          this.recsLoaded[i].created_by = config.SV_USER_ID
          this.recsLoaded[i].update_by = config.SV_USER_ID
          this.recsLoaded[i].action_by = config.SV_USER_ID
          if (curRec.delivered_dt) {
            tmpDt = curRec.delivered_dt.split('-')
            curRec.delivered_dt = handy.formatDBDate(new Date(tmpDt[2], tmpDt[1] - 1, tmpDt[0]))
          }
          if (!curRec.order_number) {
            curRec.order_number = null
          }
          if (!curRec.supplier_invoice_no) {
            curRec.supplier_invoice_no = null
          }
          if (!curRec.status) {
            curRec.status = 'In Progress'
          }
          if (!curRec.remarks) {
            curRec.remarks = null
          }
          if (!curRec.uni_invoice_number) {
            curRec.uni_invoice_number = null
          }
          // create record
          await this.axios.post(config.API_URL + '/invoiceTracker/create', this.recsLoaded[i])
          .then(response => {
            curRec.load_status = 'Loaded'
            this.totLoaded++
          })
          .catch(err => {
            curRec.error = err.response.data
            curRec.load_status = 'Failed'
            this.totFail++
          })
        }
      } // for every record
      if (!this.totFail) {
        this.msg('Uploaded successfully', 1)
        this.loadInvoiceTrackerList()
        this.lAction = 'view'
      }
      this.loadInProgress = false
      this.beingSaved = false
    },
    deleteInv (curInv) {
      if (!confirm('Sure, you want to delete the invoice ?')) {
        return
      }
      // up in db
      this.beingSaved = true
      curInv.is_deleted = '1'
      this.axios.post(config.API_URL + '/invoiceTracker/delete', curInv)
      .then(response => {
        // refresh stats
        this.beingSaved = false
        this.loadInvoiceTrackerList()
      })
      .catch(err => {
        this.msg(err)
        this.beingSaved = false
      })
    },
    pickFile () {
      this.$refs.fileInput.click()
    },
    loadFilesFromFileBrowser (curInv) {
      var maxSize = 2 // MBs
      const files = event.target.files
      if (!curInv.files) {
        curInv.files = []
      }
      Array.from(files).forEach((file) => {
        if (this.validateSize(file, maxSize)) {
          let currentDate = new Date()
          let time = currentDate.getHours() + "-" + currentDate.getMinutes() + "-" + currentDate.getSeconds()
          const fileReader = new FileReader()
          const getResult = new Promise(resolve => {
            fileReader.onload = e => {
              curInv.files.push({
                file_url: e.target.result.split(',')[1],
                file_name: file.name.split('.')[0] + '_' + handy.formatDBDate(currentDate) + '_' + time + '.' + file.name.split('.')[1],
                is_selected: true,
                is_changed: true
              })
              this.$forceUpdate()
            }
          })
          fileReader.readAsDataURL(file)
          return getResult.then(file => {
            return file
          })
        } else {
          alert("File : " + file.name + " - size must under " + maxSize + " MBs");
        }
      })
    },
    validateSize(inputFile, maxSize) {
      const fileSize = inputFile.size / 1024 / 1024; // in MiB
      if (fileSize <= maxSize) {
        return true
      } else {
        return false
      }
    },
    removeSelectedFile (curFile) {
      curFile.is_selected = false
      this.$forceUpdate()
    },
    loadInvAttachment (curInv, curInvDet) {
      var path = require('path')
      var qry = {
        params: {
          inv_id: curInv
        }
      }
      this.lTimeLine.fileUrls = []
      this.axios.get(config.API_URL + '/getAttachmentByInvId/', qry)
      .then(response => {
        this.lTimeLine.fileUrls = response.data
        // make notes if they have done any change while updating the ticket
        var fileUrls = this.lTimeLine.fileUrls.filter(rec => rec.action === 'Invoice Created' || rec.action === 'Invoice Updated')
        if (fileUrls.length > 0) {
          this.lInv.files = []
          fileUrls.forEach((rec) => {
            this.lInv.files.push({
              extension: rec.file_url.split('.')[1],
              file_url: rec.file_url,
              file_name: rec.file_url ? path.basename(rec.file_url) : '',
              is_selected: true,
              is_changed: false,
              action: rec.action,
              inv_track_det_id: rec.inv_track_det_id,
              inv_id: rec.inv_id
            })
          })
        }
        this.lTimeLine.attachImages = []
        this.lTimeLine.attachFile = []
        this.lTimeLine.fileUrls.forEach(rec => {
          rec.extension = rec.file_url.split('.')[1]
          if (rec.extension.toLowerCase() === 'png' || rec.extension.toLowerCase() === 'jpg' || rec.extension.toLowerCase() === 'gif') {
            this.lTimeLine.attachImages.push({
              extension: rec.file_url.split('.')[1],
              file_url: rec.file_url,
              file_name: rec.file_url ? path.basename(rec.file_url) : '',
              is_selected: true,
              is_changed: false,
              action: rec.action,
              inv_track_det_id: rec.inv_track_det_id,
              inv_id: rec.inv_id
            })
          } else {
            this.lTimeLine.attachFile.push({
              extension: rec.file_url.split('.')[1],
              file_url: rec.file_url,
              file_name: rec.file_url ? path.basename(rec.file_url) : '',
              is_selected: true,
              is_changed: false,
              action: rec.action,
              inv_track_det_id: rec.inv_track_det_id,
              inv_id: rec.inv_id
            })
          }
        })
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, true)
        this.lTimeLine.fileUrls = []
      })
    },
    searchInvoice () {
      if ((!this.lRep.proj_list || !this.lRep.proj_list.length) && (!this.lRep.vendorsupplier_list || !this.lRep.vendorsupplier_list.length) && !this.lRep.vendorsupplier_cat_list && !this.lRep.order_number && !this.lRep.status && !this.lRep.inv_type && !this.lRep.delivered_from_dt && !this.lRep.delivered_to_dt) {
        this.msg('Please enter any search criteria', 0)
        return
      } else if (this.lRep.delivered_from_dt && !this.lRep.delivered_to_dt) {
        this.lRep.delivered_to_dt = this.lRep.delivered_from_dt
      }
      var qry = {
        params: {
        }
      }
      qry.params = this.lRep
      qry.params.vendor_id = config.VENDOR_ID
      this.beingSaved = true
      this.axios.get(config.API_URL + '/getInvoiceTrackerList/', qry)
      .then(response => {
        this.searchinvoiceList = response.data
        if (!this.searchinvoiceList.length) {
          this.msg('No records found for given search criteria', 0)
        }
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err)
        this.searchinvoiceList = []
        this.beingSaved = false
      })
    },
    clear () {
      this.lRep.proj_list = []
      this.lRep.vendorsupplier_list = []
      this.lRep.vendorsupplier_cat_list = []
      this.lRep.inv_type = []
      this.lRep.status = []
      this.lRep.order_number = []
      this.searchinvoiceList.length = []
    },
    loadVendorSuppliersDet () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getVendorSuppliersDet/', qry)
      .then(response => {
        this.vendorSuppliersList = response.data

      })
      .catch(err => {
        this.msg(err, 0)
      })
    }
  }
}
</script>
